import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Documents } from 'src/infrastructure/enums/documents';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent extends HistoryBaseComponent implements OnInit {

  private _assetsDocumentStringPath = 'https://app.shareme.co/assets/docs/'

  constructor(
    protected location: Location,
    protected historyService: HistoryService

  ) { 
    super(location, historyService);
    this._pageTitle = 'documents'
  }

  ngOnInit(): void {
  }

  openDocument(document: string) {
    window.open(this._assetsDocumentStringPath + document, '_blank')
  }

  get files() {
    return Documents;
  }

}
